import { useSelector } from "react-redux";

const useFeatureFlags = requiredFeatureNames => {
  const featureFlags = useSelector(state => state.featureFlags.features);

  return requiredFeatureNames?.reduce((enabledFlags, featureName) => {
    const feature = featureFlags?.find?.(
      feature => feature?.name === featureName
    );
    enabledFlags.push(!!feature?.enabled);

    return enabledFlags;
  }, []);
};

export default useFeatureFlags;
